import {Switch} from '@eCommerce/frontend-legacy-shared-library-native';
import {Box, Flex, Text} from 'native-base';
import React from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';
import {useTheme} from 'styled-components/native';

interface GridListViewToggleProps {
  isListView: boolean;
  setListView: () => void;
}

const GridListViewToggle: React.FC<GridListViewToggleProps> = ({
  isListView,
  setListView,
}) => {
  const theme = useTheme();
  const {paleSky} = theme.colors;
  return (
    <Box>
      <Flex flexDirection="row" alignItems="center">
        <Icon
          name="border-all"
          size={12}
          color={paleSky}
          style={{
            marginRight: theme.space[1],
          }}
        />
        <Text accessibilityLabel="Display Offers in a grid view" mr={2}>
          Grid
        </Text>
        <Switch
          accessibilityLabel="Switch beetween displaying Offers in a list or grid view"
          isChecked={isListView}
          onToggle={setListView}
        />
        <Icon
          name="list"
          size={12}
          color={paleSky}
          style={{
            marginLeft: theme.space[1],
          }}
          solid
        />
        <Text accessibilityLabel="Display Offers in a list view" ml={1}>
          List
        </Text>
      </Flex>
    </Box>
  );
};

export default GridListViewToggle;
